export type CheckoutStep = "auth" | "user-form" | "card-form" | "success";

export interface CheckoutProgressStep {
  label: string;
  done: boolean;
  active: boolean;
}

const CARD_STEPS = ["Datos", "Pago", "Confirmación"];
const DIRECT_STEPS = ["Datos", "Confirmación"];

export const stepsForMethod = (paymentMethod?: string | null): string[] =>
  paymentMethod === "cubopago" ? CARD_STEPS : DIRECT_STEPS;

const activeIndexForStep = (
  currentStep: CheckoutStep,
  total: number,
  onPaymentSubStep: boolean,
  isCard: boolean
): number => {
  if (currentStep === "user-form") {
    // Con tarjeta, elegir el método ya es la fase de pago: "Pago" se activa en ese
    // sub-paso, no recién al entrar al formulario de tarjeta.
    return isCard && onPaymentSubStep ? Math.min(1, total - 1) : 0;
  }
  if (currentStep === "card-form") return Math.min(1, total - 1);
  return total - 1;
};

export const deriveSteps = (
  paymentMethod: string | null | undefined,
  currentStep: CheckoutStep,
  onPaymentSubStep = false
): CheckoutProgressStep[] => {
  const labels = stepsForMethod(paymentMethod);
  const activeIndex = activeIndexForStep(
    currentStep,
    labels.length,
    onPaymentSubStep,
    paymentMethod === "cubopago"
  );

  return labels.map((label, index) => {
    if (currentStep === "success") {
      return { label, done: true, active: false };
    }
    return {
      label,
      done: index < activeIndex,
      active: index === activeIndex,
    };
  });
};
